module.exports = __webpack_public_path__ + "img/hand_up.648b5df8.svg";